import React from 'react';
import { LaunchBanner } from '../components/landing/LaunchBanner';
import { HeroSection } from '../components/landing/HeroSection';
import { PremiumShowcaseSection } from '../components/landing/PremiumShowcaseSection';
import { ProblemSection } from '../components/landing/ProblemSection';
import { HowItWorksSection } from '../components/landing/HowItWorksSection';
import { TestimonialsSection } from '../components/landing/TestimonialsSection';
import { ExpertSection } from '../components/landing/ExpertSection';
import { PricingSection } from '../components/landing/PricingSection';
import { GuaranteeSection } from '../components/landing/GuaranteeSection';
import { FAQSection } from '../components/landing/FAQSection';
import { FinalCTASection } from '../components/landing/FinalCTASection';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-brand-cream font-sans text-slate-900 selection:bg-brand-terracotta/20" data-id="element-680">
      <LaunchBanner data-id="element-681" />
      <main data-id="element-682">
        <HeroSection data-id="element-683" />
        <PremiumShowcaseSection data-id="element-684" />
        <ProblemSection data-id="element-685" />
        <HowItWorksSection data-id="element-686" />
        <TestimonialsSection data-id="element-687" />
        <ExpertSection data-id="element-688" />
        <PricingSection data-id="element-689" />
        <GuaranteeSection data-id="element-690" />
        <FAQSection data-id="element-691" />
        <FinalCTASection data-id="element-692" />
      </main>
      <Footer data-id="element-693" />
    </div>;
}